import { HStack, IconButton, NumberInput } from "@chakra-ui/react"
import * as React from "react"
import { LuMinus, LuPlus } from "react-icons/lu"

export const StepperInput = React.forwardRef(function StepperInput(props, ref) {
  const { label, min = 1, max, ...rest } = props
  return (
    <NumberInput.Root {...rest} unstyled ref={ref} min={min} max={max}>
      {label && <NumberInput.Label>{label}</NumberInput.Label>}
      <HStack gap="0">
        <DecrementTrigger />
        <NumberInput.Input
          textAlign="center"
          fontSize="sm"
          minW="3ch"
          width="6ch"
          h="9"
          bg="bg"
          borderTop="1px solid"
          borderBottom="1px solid"
          borderLeft="none"
          borderRight="none"
          borderColor="colorPalette.border"
          borderRadius="0"
          px="2"
          _focus={{ outline: "none", borderColor: "colorPalette.focusRing" }}
          _hover={{ borderColor: "colorPalette.border" }}
        />
        <IncrementTrigger />
      </HStack>
    </NumberInput.Root>
  )
})

const DecrementTrigger = React.forwardRef(function DecrementTrigger(
  props,
  ref
) {
  return (
    <NumberInput.DecrementTrigger {...props} asChild ref={ref}>
      <IconButton variant="outline" size="sm" borderRightRadius="0">
        <LuMinus />
      </IconButton>
    </NumberInput.DecrementTrigger>
  )
})

const IncrementTrigger = React.forwardRef(function IncrementTrigger(
  props,
  ref
) {
  return (
    <NumberInput.IncrementTrigger {...props} asChild ref={ref}>
      <IconButton variant="outline" size="sm" borderLeftRadius="0">
        <LuPlus />
      </IconButton>
    </NumberInput.IncrementTrigger>
  )
})
